import { useEffect } from "react";
import "@/App.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import ServicesSection from "./components/ServicesSection";
import WhyChooseUs from "./components/WhyChooseUs";
import HowItWorks from "./components/HowItWorks";
import CTABand from "./components/CTABand";
import CommercialSection from "./components/CommercialSection";
import AboutSection from "./components/AboutSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";

function App() {
  // Scroll reveal observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -40px 0px" }
    );

    const timer = setTimeout(() => {
      document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    }, 100);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="font-body text-poly-blue-dark">
      <Header />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesSection />
        <WhyChooseUs />
        <HowItWorks />
        <CTABand
          headline="Need Reliable Laundry Service?"
          subtext="Let us handle the laundry so you can focus on what matters most. Free pickup and delivery in Mountain Home."
          ctaText="Schedule Free Pickup"
          ctaHref="#contact"
        />
        <CommercialSection />
        <AboutSection />
        <CTABand
          headline="Ready to Get Started?"
          subtext="Schedule your free pickup and delivery today, or get a custom quote for commercial laundry service."
          ctaText="Request a Quote"
          ctaHref="#contact"
          variant="blue"
        />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
